import React from 'react'
import TextInput from '../../Text'
import validate from './lib/validate'

export default (props) => (
  <TextInput validate={validate} {...props} />
)
